import { AssetGroupResolver } from "../core/resolvers/SDKAssetGroupResolver";
import { ComponentGroupResolver } from "../core/resolvers/SDKComponentGroupResolver";
import { TokenGroupResolver } from "../core/resolvers/SDKTokenGroupResolver";
import { TokenResolver } from "../core/resolvers/SDKTokenResolver";
import { Asset } from "../model/assets/SDKAsset";
import { Brand } from "../model/base/SDKBrand";
import { DesignSystem } from "../model/base/SDKDesignSystem";
import { DesignSystemVersion, } from "../model/base/SDKDesignSystemVersion";
import { Component, } from "../model/components/SDKComponent";
import { ElementDataView, } from "../model/elements/SDKElementDataView";
import { ElementProperty, } from "../model/elements/SDKElementProperty";
import { ElementPropertyValue, } from "../model/elements/values/SDKElementPropertyValue";
import { Membership, } from "../model/membership/SDKMembership";
import { ResourceFont, } from "../model/resources/SDKResourceFont";
import { Source } from "../model/support/SDKSource";
import { User } from "../model/users/SDKUser";
import { UserMembership } from "../model/users/SDKUserMembership";
export class RawUtils {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Build objects out of raw data
    /** Builds components from raw data */
    static buildComponentsFromRaw(rawData, properties, propertyValues) {
        return rawData.map((component) => new Component(component, properties, propertyValues));
    }
    /** Build component groups */
    static buildComponentGroupsFromRaw(rawData, components) {
        const resolver = new ComponentGroupResolver(components);
        const groups = resolver.resolveGroupData(rawData);
        return groups;
    }
    /** Builds assets from raw data */
    static buildAssetsFromRaw(rawData, sources) {
        // Manage duplicates
        const assetNames = new Map();
        for (const item of rawData) {
            if (item.exportProperties.isAsset) {
                assetNames.set(item.meta.name.toLowerCase(), 0);
            }
        }
        // Transform only exportable designComponents into assets
        const assets = [];
        for (const asset of rawData) {
            const lowercasedName = asset.meta.name.toLowerCase();
            if (asset.exportProperties.isAsset) {
                // @ts-expect-error TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
                assets.push(new Asset(asset, assetNames.get(lowercasedName), sources));
                // Increase number of duplicates
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                assetNames.set(lowercasedName, assetNames.get(lowercasedName) + 1);
            }
        }
        return assets;
    }
    /** Build asset groups */
    static buildAssetGroupsFromRaw(rawData, assets) {
        const resolver = new AssetGroupResolver(assets);
        const result = resolver.resolveGroupData(rawData);
        return result;
    }
    /** Builds tokens from raw data */
    static buildTokensFromRaw(rawData, properties, propertyValues, propertyViews, tokenGroups, sources, designSystemId, versionId) {
        const resolver = new TokenResolver(designSystemId, versionId);
        const result = resolver.resolveTokenData(rawData, tokenGroups, properties, propertyViews, propertyValues, sources);
        return result;
    }
    /** Build token groups */
    static buildTokenGroupsFromRaw(rawData) {
        const resolver = new TokenGroupResolver();
        const result = resolver.resolveGroupData(rawData);
        return result;
    }
    /** Builds elements from raw data */
    static buildElementsFromRaw(rawData) {
        return {
            propertyValues: rawData.propertyValues.map((value) => new ElementPropertyValue(value)),
            propertyViews: rawData.propertyViews.map((view) => new ElementDataView(view)),
            propertyDefinitions: rawData.propertyDefinitions.map((definition) => new ElementProperty(definition)),
        };
    }
    /** Build sources */
    static buildSourcesFromRaw(rawData) {
        return rawData.map((source) => new Source(source));
    }
    /** Build font resources */
    static buildFontResourcesFromRaw(rawData) {
        return rawData.map((d) => new ResourceFont(d));
    }
    /** Builds memberships */
    static buildMembershipsFromRaw(rawData) {
        return rawData.map((membership) => new Membership(membership));
    }
    /** Builds workspace memebers */
    static buildWorkspaceMembersFromRaw(rawData) {
        return rawData.map((membership) => new UserMembership(membership));
    }
    /** Builds design systems */
    static buildDesignSystemsFromRaw(rawData) {
        return rawData.map((designSystem) => new DesignSystem(designSystem));
    }
    /** Builds versions */
    static buildVersionsFromRaw(rawData) {
        return rawData.map((version) => new DesignSystemVersion(version));
    }
    /** Builds brands */
    static buildBrandsFromRaw(rawData) {
        return rawData.map((brand) => new Brand(brand));
    }
    /** Builds user */
    static buildUserFromRaw(rawData) {
        return new User(rawData);
    }
}
